import { render, staticRenderFns } from "./TabelaPrecosProdutoDialogo.vue?vue&type=template&id=013fd9d1&"
import script from "./TabelaPrecosProdutoDialogo.vue?vue&type=script&lang=js&"
export * from "./TabelaPrecosProdutoDialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports